import { countOffset, sortToObject } from 'src/common/utils'
import { useFilter, usePagination } from 'src/hooks'
import {
  initialtConsumerChallengesFilter,
  useGetConsumerChallanges,
} from 'src/hooks/challenges/use-get-consumer-challanges.hook'
import {
  defaulConsumerChallengetLimit,
  defaultPage,
  defaultConsumerChallengeSort,
  longerSearchDelay,
} from 'src/constants'
import { useState } from 'react'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { Filter } from '../filter'
import { useTranslation } from 'react-i18next'
import { Loader } from '../loader'
import { PaginationButtons, PaginationContext } from '../pagination-buttons'
import { MobileBottomLayout } from '../mobile-bottom-layout'
import { ConsumerChallangesTable } from './table'

export const ConsumerChallengesComponent = () => {
  const [t] = useTranslation()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const [sort, setSort] = useState(defaultConsumerChallengeSort)
  const [filter, setFilter] = useFilter({ initialState: initialtConsumerChallengesFilter })

  const { page, setPage, rowsPerPage, setRowsPerPage } = usePagination(
    defaultPage,
    defaulConsumerChallengetLimit,
  )

  const { data, isLoading } = useGetConsumerChallanges({
    ...filter,
    offset: countOffset(page, rowsPerPage),
    limit: rowsPerPage,
    ...sortToObject(sort),
  })

  const paginationValues = {
    count: data?.count ?? 0,
    page: page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    isShown: !!data && data.count > rowsPerPage,
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Filter
        enableDebounce
        debounceDelay={longerSearchDelay}
        sort={sort}
        setSort={setSort}
        searchFieldText={t('search-input-placeholder.v')}
        filter={filter}
        setFilter={setFilter}
        selectionOptions={[]}
        initialState={initialtConsumerChallengesFilter}
        // isFilterOpened={isFilterOpened ? isFilterOpened === 'true' : true}
      />

      {isLoading && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            m: '30px',
          }}
        >
          <Loader isStatic />
        </Box>
      )}

      <PaginationContext.Provider value={paginationValues}>
        {!isLoading && <ConsumerChallangesTable data={data?.data} sort={sort} setSort={setSort} />}
        {!isTablet && !isLoading && <PaginationButtons disableLimitSelect />}
        {isTablet && !isLoading && (
          <MobileBottomLayout>
            <PaginationButtons buttonsOnly />
          </MobileBottomLayout>
        )}
      </PaginationContext.Provider>
    </Box>
  )
}
